import type { Bot } from '@medplum/fhirtypes';

const BOT_PAGE_SIZE = 200;

/** Fetch all Bot resources via offset pagination (no silent 200-cap). */
export async function fetchAllBots(
  medplum: { searchResources: (resourceType: 'Bot', query: Record<string, string>) => Promise<Bot[]> },
): Promise<Bot[]> {
  const all: Bot[] = [];
  let offset = 0;
  for (;;) {
    const page = await medplum.searchResources('Bot', {
      _count: String(BOT_PAGE_SIZE),
      _offset: String(offset),
      _sort: 'name',
    });
    all.push(...page);
    if (page.length < BOT_PAGE_SIZE) break;
    offset += BOT_PAGE_SIZE;
  }
  return all;
}
